<ng-container *transloco="let t" class="container">
  <div class="modal-header d-block">
    <div class="d-flex align-items-center">
      <h5 class="modal-title pb-1">{{ t('request.details') | uppercase}}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="onDismissClick()"></button>
    </div>
  </div>

  <div class="divider-horizontal"></div>

  <div class="modal-body">
    <div class="fs-18">
      <div class="py-2">
        <ng-container *ngTemplateOutlet="requestHeader"></ng-container>
      </div>

      <div>
        <div class="px-3 py-4">
          <div *ngIf="request.type === RequestTypes.ORGANISER">
            <ng-container *ngTemplateOutlet="organiserData; context: {organiser: request.organiserRequest }"></ng-container>
          </div>

          <div *ngIf="league">
            <ng-container *ngTemplateOutlet="leagueData"></ng-container>
          </div>

          <div *ngIf="(events.length ?? 0 > 0)">
            <div *ngFor="let event of events" class="mb-3">
              <ng-container *ngTemplateOutlet="eventData; context: { event: event }"></ng-container>
              <div [ngbCollapse]="!eventContentOpen.get(event.id!)" [class.pt-3]="eventContentOpen.get(event.id!)">
                <ng-container *ngFor="let race of event?.racesList">
                  <ng-container *ngTemplateOutlet="raceData; context: { race: race }"></ng-container>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="divider-horizontal"></div>

  <div class="modal-footer p-3 pe-2">
    <div class="d-flex justify-content-end">
      <app-rounded-button (onClick)="onDismissClick()"
                          [label]="t('app.common.cancel')"
                          [btnClass]="'rounded-button--transparent fs-14 py-2'"></app-rounded-button>
      @if (actionsAllowed) {
        <div class="ms-1 me-2">
          <app-rounded-button (onClick)="onDecline()"
                              [label]="t('request.action.decline')"
                              [btnClass]="'rounded-button--solid fs-14 py-2'"></app-rounded-button>
        </div>
        <app-rounded-button (onClick)="onAccept()"
                            [label]="t('request.action.accept')"
                            [btnClass]="'rounded-button--solid fs-14 py-2'"></app-rounded-button>
      }
    </div>
  </div>

  <ng-template #requestHeader>
    <div class="px-3">
      <div *ngIf="request.type === RequestTypes.ORGANISER">
        <ng-container *ngTemplateOutlet="requestData; context:
                           { src: request.userDetail?.picture,
                             userName: (request.userDetail?.firstname ?? '') + ' ' + (request.userDetail?.lastname ?? '')
                           }">
        </ng-container>
      </div>
      <div  *ngIf="request.type === RequestTypes.PUBLISH_EVENT || request.type === RequestTypes.ADD_EVENT_TO_LEAGUE || request.type === RequestTypes.PUBLISH_LEAGUE">
        <ng-container *ngTemplateOutlet="requestData; context:
                           { src: request.organiserRequest?.image,
                             userName: (request.organiserRequest?.fullName ?? '')
                           }">
        </ng-container>
      </div>
    </div>
  </ng-template>

  <ng-template #requestData let-src="src" let-userName="userName">
    <div class="request-container">
      <div class="request-header">
        <div *ngIf="src">
          <img class="avatar" [src]="src" />
        </div>

        <div class="meta">
          <div class="name">{{userName}}</div>
          <div class="small-text">{{ t('request.date.created') }}: {{request.created | localizedDate:'short'}}</div>
        </div>

          <div class="badges">
            <div class="pe-2">
              <div class="status-badge fs-14"
                   [ngClass]="{
                                'on-hold': request.type === 0,
                                'accepted': request.type === 1,
                                'publishing': request.type === 2,
                                'blue': request.type === 3,
                               }">
                <span> {{ t("request.type." + request.type) | uppercase }} </span>
              </div>
            </div>
            <div>
              <div
                class="status-badge fs-14"
                [ngClass]="{
                        'on-hold': request.requestStatus === 0,
                        'accepted': request.requestStatus === 1,
                        'denied': request.requestStatus === 2
                      }"
                *ngIf="request.comment; else noTooltip"
                [ngbTooltip]="request.comment"
                [placement]="'bottom-left'"
                [container]="'body'"

              >
                      <span>
                        {{ t("request.status." + request.requestStatus) | uppercase }}
                      </span>
                <i class="bi bi-info-circle info-icon ps-2"></i>
              </div>
              <ng-template #noTooltip>
                <div
                  class="status-badge fs-14"
                  [ngClass]="{
                          'on-hold': request.requestStatus === 0,
                          'accepted': request.requestStatus === 1,
                          'denied': request.requestStatus === 2
                        }"
                >
                        <span>
                          {{ t("request.status." + request.requestStatus) | uppercase }}
                        </span>
                </div>
              </ng-template>
            </div>
          </div>
      </div>
    </div>
  </ng-template>

  <ng-template #leagueData>
    <div class="heading-container__league d-flex justify-content-between mb-3">
      <div class="d-flex p-3 align-items-center">
        <div *ngIf="league?.imageMedium">
          <img [src]="league!.imageMedium" width="75px" height="75px" style="border-radius: 50%; object-fit: cover;"/>
        </div>
        <div class="ps-3 info">
          <div class="small-text">
            {{t("app.common.league")}}
          </div>

          <p class="name text-uppercase">
            <app-language-output [hrLabel]="league?.name" [enLabel]="league?.nameEng" [bsLabel]="league?.nameBs"
                                 [itLabel]="league?.nameIta" [siLabel]="league?.nameSlo" [srLabel]="league?.nameSr"
                                 [defaultLanguage]="league?.defaultLanguage" [languages]="languages"/>
          </p>

          <div class="d-flex justify-content-between">
            <div class="info__details d-flex flex-column flex-xxl-row align-items-center">
              <div *ngIf="league?.sportId" class="d-flex d-xxl-none pb-2">
                <div class="badge-holder">
                  <div class="badge-holder__badge sport-badge info__details--block">
                    <p class="text-uppercase">{{t("app.common.sports." + league!.sportId)}}</p>
                  </div>
                </div>
              </div>

              <div *ngIf="league?.sportId" class="d-none d-xxl-flex info__details--block align-items-center">
                <p class="text-uppercase fs-14">{{t("app.common.sports." + league!.sportId)}}</p>
              </div>

              <div class="d-flex align-items-center info__details--block">
                <p class="fs-14">
                  <app-event-date-display [start]="league?.start" [end]="league?.end" [showIcon]="true"/>
                </p>
              </div>
              <app-location-display
                      [countries]="league?.countries"
                      [showList]="true"
                      [cssClass]="'fs-14'"
                      [format]="'name'"
                      [listSizeBreakPoint]="2"/>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column align-items-end justify-content-end">
        <div *ngIf="showLeagueDetailsButton" class="d-flex pb-3 justify-content-end">
          <app-button-alt [buttonColor]="'transparent'" [textColor]="'var(--teal-500)'" [buttonHeight]="'20px'"
                          [text]="t('app.common.view.details') | uppercase" [borderColor]="'transparent'"
                          (onClickCallback)="openLeagueDetailsInNewTab(league!)"> </app-button-alt>
        </div>
      </div>
    </div>

  </ng-template>

  <ng-template #eventData let-event="event">
      <div class="heading-container d-flex justify-content-between">
        <div class="d-flex p-3 align-items-center">
          <div class="d-flex">
            <div *ngIf="event?.imageMedium">
              <img [src]="event!.imageMedium" width="75px" height="75px" style="border-radius: 50%; object-fit: cover;"/>
            </div>
          </div>

          <div class="ps-3 info">
            <div class="small-text">
              {{t("app.common.event")}}
            </div>

            <p class="name text-uppercase">
              <app-language-output [hrLabel]="event?.name" [srLabel]="event?.nameSr"
                                   [enLabel]="event?.nameEng" [itLabel]="event?.nameIta"
                                   [bsLabel]="event?.nameBs" [siLabel]="event?.nameSlo"
                                   [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
            </p>

            <div class="d-flex justify-content-between">
              <div class="info__details d-flex flex-column flex-xxl-row align-items-center">
                <div *ngIf="event!.sportOne" class="d-flex d-xxl-none pb-2">
                  <div class="badge-holder">
                    <div class="badge-holder__badge sport-badge info__details--block">
                      <p class="text-uppercase">{{t("app.common.sports." + event!.sportOne)}}</p>
                    </div>
                  </div>
                </div>
                <div *ngIf="event!.sportOne" class="d-none d-xxl-flex info__details--block align-items-center">
                  <p class="text-uppercase fs-14">{{t("app.common.sports." + event!.sportOne)}}</p>
                </div>

                <div class="d-flex align-items-center info__details--block">
                  <p class="fs-14">
                    <app-event-date-display [start]="event?.start" [end]="event?.end" [showIcon]="true"/>
                  </p>
                </div>
                <app-location-display
                        [city]="event.city"
                        [countryId]="event.country"
                        [cssClass]="'fs-14'" />
              </div>
              </div>
            </div>
          </div>
        <div class="d-flex flex-column align-items-end"
             [ngClass]="{'justify-content-between': ((event.racesList?.length ?? 0) > 0),
                          'justify-content-end': !((event.racesList?.length ?? 0) > 0)}">
          <div class="mt-3 me-3">
            <div class="scale-85">
              <button *ngIf="(event.racesList?.length ?? 0) > 0"
                      class="btn btn-outline-secondary btn-circle"
                      (click)="toggleCollapse(event.id!)"
                      [class.active-btn]="eventContentOpen.get(event.id!)">
                <i class="fas"
                   [class.fa-chevron-down]="!eventContentOpen.get(event.id!)"
                   [class.fa-chevron-up]="eventContentOpen.get(event.id!)"></i>
              </button>
            </div>
          </div>

          <div *ngIf="showEventDetailsButton" class="d-flex pb-3 justify-content-end">
            <app-button-alt
                    [buttonColor]="'transparent'"
                    [textColor]="'var(--teal-500)'"
                    [buttonHeight]="'20px'"
                    [text]="t('app.common.view.details') | uppercase"
                    [borderColor]="'transparent'"
                    (onClickCallback)="openEventDetailsInNewTab(event)">
            </app-button-alt>
          </div>
        </div>
      </div>
  </ng-template>


  <ng-template #raceData let-race="race">
        <div class="race-list-item flex-column flex-xxl-row d-flex align-items-start p-3 mb-4 mb-xxl-0">
          <div class="flex-grow-1 ps-0 ps-xxl-3">
            <p class="name">
              <app-language-output [hrLabel]="race?.name" [enLabel]="race?.nameEng"
                                   [srLabel]="race?.nameSr" [bsLabel]="race?.nameBs"
                                   [itLabel]="race?.nameIta" [siLabel]="race?.nameSlo"
                                   [defaultLanguage]="request.event?.defaultLanguage" [languages]="languages"/>
              + {{ race?.length ? (race?.length | raceLengthFormat:translocoService.getActiveLang()) : '-' }}
            </p>

            <div class="info-details d-flex mb-0">
              <div class="d-flex">
                <p class="fs-14">
                  {{ t("event.item.date") + ":" }}&nbsp;
                </p>
                <p class="fs-14">
                  {{ race.raceStart | localizedDate:"shortDate" }}
                </p>
              </div>
              <div class="d-flex">
                <p class="fs-14"> {{ t("event.item.start") + ":" }}&nbsp; </p>
                <p class="fs-14"> {{ race.raceStart | localizedDate:"HH:mm" }} </p>
              </div>
            </div>
          </div>
        </div>
  </ng-template>

  <ng-template #organiserData let-organiser="organiser">
      <div class="heading-container p-3 pt-1">
        <div class="small-text pb-3">
          {{ t('request.form.data') }}
        </div>

        <div class="d-flex justify-content-start align-items-center">
          <div class="col-6 d-flex align-items-center">
            <ng-container *ngTemplateOutlet="detailRow; context:
                           { label: t('organiser.details.name'), value: organiser?.name }">
            </ng-container>
          </div>
          <div class="col-6 d-flex align-items-center">
            <ng-container *ngTemplateOutlet="detailRow; context:
                          { label: t('organiser.details.web'), value: organiser?.website }">
            </ng-container>
          </div>
        </div>

        <div class="pt-2 d-flex justify-content-start align-items-center">
          <div class="col-6 d-flex align-items-center">
              <ng-container *ngTemplateOutlet="detailRow; context:
                           { label: t('organiser.details.full.name'), value: organiser?.fullName }">
              </ng-container>
          </div>
          <div class="col-6 d-flex align-items-center">
            <ng-container *ngTemplateOutlet="detailRow; context:
                          { label: t('organiser.details.email'), value: organiser?.email }">
            </ng-container>
          </div>
        </div>

        <div class="pt-2 d-flex justify-content-start align-items-center">
          <div class="col-6 d-flex align-items-center">
            <ng-container *ngTemplateOutlet="detailRow; context:
                          { label: t('organiser.details.address'), value: organiser?.address }">
            </ng-container>
          </div>
          <div class="col-6 d-flex align-items-center">
            <ng-container *ngTemplateOutlet="detailRow; context:
                          { label: t('organiser.details.phone'), value: organiser?.phone }">
            </ng-container>
          </div>

        </div>

        <div class="pt-2 d-flex justify-content-start align-items-center">
          <div class="col-6 d-flex align-items-center">
            <ng-container *ngTemplateOutlet="detailRow; context:
                          { label: t('organiser.details.place'), value: organiser?.place }">
            </ng-container>
          </div>
          <div class="col-6 d-flex align-items-center">
            <ng-container *ngTemplateOutlet="detailRow; context:
                          { label: t('app.common.zip'), value: organiser?.zip }">
            </ng-container>
          </div>
        </div>

        <div class="pt-2 d-flex justify-content-start align-items-center">
          <div class="col-6 d-flex align-items-center">
            <ng-container *ngTemplateOutlet="detailRow; context:
                           { label: t('app.common.country'), value: organiser.country?.countryId ? t('app.common.country.' + request.organiserRequest!.country!.countryId) : '-'}">
            </ng-container>
          </div>
        </div>
      </div>
  </ng-template>

  <ng-template #detailRow let-label="label" let-value="value" let-listValue="list">
      <div class="col-12 d-flex align-items-center detail-row">
        <div class="col-5">
          <span class="fw-600">{{ label }}</span>
        </div>
        <div class="col-7 ps-1">
          <ng-container *ngIf="listValue?.length > 0; else singleValue">
            <ul class="mb-0 ps-3">
              <li *ngFor="let item of listValue">{{ item  || '-'}}</li>
            </ul>
          </ng-container>

          <ng-template #singleValue>
            {{ value || '-' }}
          </ng-template>
        </div>
      </div>
  </ng-template>

</ng-container>
